/**
 * Fetch public branding settings
 * Reads logo and background URLs from localStorage (set by admin in System Settings)
 * 
 * @returns {Promise<{logoUrl: string|null, logoSize: number, loginBackgroundUrl: string|null}>}
 */
export async function fetchPublicBranding() {
  try {
    // Read branding from localStorage (set by admin in System Settings)
    if (typeof window !== 'undefined') {
      const logoUrl = localStorage.getItem('company_logo_url');
      const logoSize = parseInt(localStorage.getItem('company_logo_size') || '80');
      const loginBackgroundUrl = localStorage.getItem('login_background_url');

      const result = {
        logoUrl: logoUrl || null,
        logoSize: logoSize || 80,
        loginBackgroundUrl: loginBackgroundUrl || null
      };
      return result;
    }

    return {
      logoUrl: null,
      logoSize: 80,
      loginBackgroundUrl: null
    };
  } catch (error) {
    console.error('Error fetching public branding:', error);
    return {
      logoUrl: null,
      logoSize: 80,
      loginBackgroundUrl: null
    };
  }
}
